<template>
  <div>
    <card class="text-center">
      <template slot="header">
        <h4 class="card-title">총 광고료 (원, VAT 별도)</h4>
      </template>
      <div class="table-full-width table-tasks">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 0px"
                  :data="allAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="1월">
            <template slot-scope="props">
              <el-input v-model="props.row.m1" @keyup.native="commas('m1', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="2월">
            <template slot-scope="props">
              <el-input v-model="props.row.m2" @keyup.native="commas('m2', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="3월">
            <template slot-scope="props">
              <el-input v-model="props.row.m3" @keyup.native="commas('m3', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="4월">
            <template slot-scope="props">
              <el-input v-model="props.row.m4" @keyup.native="commas('m4', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="5월">
            <template slot-scope="props">
              <el-input v-model="props.row.m5" @keyup.native="commas('m5', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="6월">
            <template slot-scope="props">
              <el-input v-model="props.row.m6" @keyup.native="commas('m6', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="allAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="7월">
            <template slot-scope="props">
              <el-input v-model="props.row.m7" @keyup.native="commas('m7', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="8월">
            <template slot-scope="props">
              <el-input v-model="props.row.m8" @keyup.native="commas('m8', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="9월">
            <template slot-scope="props">
              <el-input v-model="props.row.m9" @keyup.native="commas('m9', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="10월">
            <template slot-scope="props">
              <el-input v-model="props.row.m10" @keyup.native="commas('m10', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="11월">
            <template slot-scope="props">
              <el-input v-model="props.row.m11" @keyup.native="commas('m11', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="12월">
            <template slot-scope="props">
              <el-input v-model="props.row.m12" @keyup.native="commas('m12', 'am')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer text-right">
          <el-button type="primary" @click="save('AM')" v-if="checkAuth($store.state.account.roleCode, 'ADMIN')">저장
          </el-button>
        </div>
      </div>
    </card>
    <card class="text-center">
      <template slot="header">
        <h4 class="card-title">와이드칼라</h4>
      </template>
      <div class="table-full-width table-tasks">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="this.wcStatus"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="전체수량">
            <template slot-scope="props">
              {{ props.row.totalCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="수익">
            <template slot-scope="props">
              {{ props.row.inComingCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="공실">
            <template slot-scope="props">
              {{ props.row.emptyCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="제휴">
            <template slot-scope="props">
              {{ props.row.affilizationCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="PL">
            <template slot-scope="props">
              {{ props.row.plCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="기타">
            <template slot-scope="props">
              {{ props.row.etcCount | numeral('0,0')}}개
            </template>
          </el-table-column>
        </el-table>
      </div>
    </card>
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-6" v-for="stats in wcMedias">
        <stats-card :small-title="stats.mediaName"
                    type="string"
                    :title="stats.count | numeral('0,0')">
        </stats-card>
      </div>
    </div>
    <card class="text-center">
      <template slot="header">
        <h4 class="card-title">와이드칼라 광고료 (원, VAT 별도)</h4>
      </template>
      <div class="table-full-width table-tasks">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 0px"
                  :data="wcAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="1월">
            <template slot-scope="props">
              <el-input v-model="props.row.m1" @keyup.native="commas('m1', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="2월">
            <template slot-scope="props">
              <el-input v-model="props.row.m2" @keyup.native="commas('m2', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="3월">
            <template slot-scope="props">
              <el-input v-model="props.row.m3" @keyup.native="commas('m3', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="4월">
            <template slot-scope="props">
              <el-input v-model="props.row.m4" @keyup.native="commas('m4', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="5월">
            <template slot-scope="props">
              <el-input v-model="props.row.m5" @keyup.native="commas('m5', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="6월">
            <template slot-scope="props">
              <el-input v-model="props.row.m6" @keyup.native="commas('m6', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="wcAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="7월">
            <template slot-scope="props">
              <el-input v-model="props.row.m7" @keyup.native="commas('m7', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="8월">
            <template slot-scope="props">
              <el-input v-model="props.row.m8" @keyup.native="commas('m8', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="9월">
            <template slot-scope="props">
              <el-input v-model="props.row.m9" @keyup.native="commas('m9', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="10월">
            <template slot-scope="props">
              <el-input v-model="props.row.m10" @keyup.native="commas('m10', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="11월">
            <template slot-scope="props">
              <el-input v-model="props.row.m11" @keyup.native="commas('m11', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="12월">
            <template slot-scope="props">
              <el-input v-model="props.row.m12" @keyup.native="commas('m12', 'wc')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer text-right">
          <el-button type="primary" @click="save('WC')" v-if="checkAuth($store.state.account.roleCode, 'ADMIN')">저장
          </el-button>
        </div>
      </div>
    </card>

    <card class="text-center">
      <template slot="header">
        <h4 class="card-title">디지털미디어</h4>
      </template>
      <div class="table-full-width table-tasks">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="this.dmStatus"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="전체수량">
            <template slot-scope="props">
              {{ props.row.totalCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="수익">
            <template slot-scope="props">
              {{ props.row.inComingCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="공실">
            <template slot-scope="props">
              {{ props.row.emptyCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="제휴">
            <template slot-scope="props">
              {{ props.row.affilizationCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="PL">
            <template slot-scope="props">
              {{ props.row.plCount | numeral('0,0')}}개
            </template>
          </el-table-column>
          <el-table-column
            label="기타">
            <template slot-scope="props">
              {{ props.row.etcCount | numeral('0,0')}}개
            </template>
          </el-table-column>
        </el-table>
      </div>
    </card>
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-6" v-for="stats in dmMedias">
        <stats-card :small-title="stats.mediaName"
                    type="string"
                    :title="stats.count | numeral('0,0')">
        </stats-card>
      </div>
    </div>
    <card class="text-center">
      <template slot="header">
        <h4 class="card-title">디지털미디어 광고료 (원, VAT 별도)</h4>
      </template>
      <div class="table-full-width table-tasks">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 0px"
                  :data="dmAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="1월">
            <template slot-scope="props">
              <el-input v-model="props.row.m1" @keyup.native="commas('m1', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="2월">
            <template slot-scope="props">
              <el-input v-model="props.row.m2" @keyup.native="commas('m2', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="3월">
            <template slot-scope="props">
              <el-input v-model="props.row.m3" @keyup.native="commas('m3', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="4월">
            <template slot-scope="props">
              <el-input v-model="props.row.m4" @keyup.native="commas('m4', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="5월">
            <template slot-scope="props">
              <el-input v-model="props.row.m5" @keyup.native="commas('m5', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="6월">
            <template slot-scope="props">
              <el-input v-model="props.row.m6" @keyup.native="commas('m6', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="dmAdvertisingFee"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="7월">
            <template slot-scope="props">
              <el-input v-model="props.row.m7" @keyup.native="commas('m7', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="8월">
            <template slot-scope="props">
              <el-input v-model="props.row.m8" @keyup.native="commas('m8', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="9월">
            <template slot-scope="props">
              <el-input v-model="props.row.m9" @keyup.native="commas('m9', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="10월">
            <template slot-scope="props">
              <el-input v-model="props.row.m10" @keyup.native="commas('m10', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="11월">
            <template slot-scope="props">
              <el-input v-model="props.row.m11" @keyup.native="commas('m11', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="12월">
            <template slot-scope="props">
              <el-input v-model="props.row.m12" @keyup.native="commas('m12', 'dm')"
                        :readonly="!checkAuth($store.state.account.roleCode, 'ADMIN')"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer text-right">
          <el-button type="primary" @click="save('DM')" v-if="checkAuth($store.state.account.roleCode, 'ADMIN')">저장
          </el-button>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Button, Row, Col, Input} from 'element-ui'
  import {Card} from 'src/components/UIComponents'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import VueMoment from 'vue-moment'
  import vueNumeralFilterInstaller from 'vue-numeral-filter';
  import StoreProxy from "../../../../proxies/StoreProxy";
  import MediaInfoProxy from "../../../../proxies/MediaInfoProxy";
  import OverviewProxy from "../../../../proxies/OverviewProxy";
  
  Vue.use(vueNumeralFilterInstaller)
  Vue.use(VueMoment)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Input)

  export default {
    components: {
      StatsCard,
      Card,
    },
    created: function () {

      this.$store.dispatch('common/setMenuTitle', "전체 현황");
      this.getWCStatus();
      this.getDMStatus();
      this.getALLStatus();
    },
    methods: {
      tableRowStyle() {

        return this.$store.state.common.tableHeaderFont10CellStyle;
      },
      getWCStatus() {
        new StoreProxy({mediaType: "WC"})
          .getStoreStatus(0, 0)
          .then((response) => {
            this.wcStatus.push(response.storeStatus);
          });
        new MediaInfoProxy()
          .getMediaCountByMediaType("WC")
          .then((response) => {
            this.wcMedias = response.mediaInfos;
          });
        this.getAdvertisingFee("WC");
      },
      getALLStatus() {
        this.getAdvertisingFee("AM");
      },
      getAdvertisingFee(mediaType) {
        new OverviewProxy()
          .find(mediaType)
          .then((response) => {
            if (mediaType === "WC") {
              this.wcAdvertisingFee.push(response.advertisingFee);
            } else if (mediaType === "DM") {
              this.dmAdvertisingFee.push(response.advertisingFee);
            } else if (mediaType === "AM") {
              this.allAdvertisingFee.push(response.advertisingFee);
            }
          });
      },
      getDMStatus() {
        new StoreProxy({mediaType: "DM"})
          .getStoreStatus(0, 0)
          .then((response) => {
            this.dmStatus.push(response.storeStatus);
          });
        new MediaInfoProxy()
          .getMediaCountByMediaType("DM")
          .then((response) => {
            this.dmMedias = response.mediaInfos;
          });
        this.getAdvertisingFee("DM");
      },
      save(mediaType) {
        let paramFee = null;
        if(mediaType === "WC") {
          paramFee = this.wcAdvertisingFee[0];
        } else if(mediaType === "DM") {
          paramFee = this.dmAdvertisingFee[0];
        } else {
          paramFee = this.allAdvertisingFee[0];
        }
        new OverviewProxy()
          .update(mediaType, paramFee)
          .then((response) => {
            if (response.header.returnCode === "OK") {
              alert("저장이 완료되었습니다.");
            } else {
              alert(response.header.resultMessages);
            }
          });
      },
      numberWithCommas(x) {
        return Vue.NumberWithCommas(x);
      },
      commas(month, mediaType) {
        if (mediaType === 'wc') {
          this.wcAdvertisingFee[0][month] = this.numberWithCommas(this.wcAdvertisingFee[0][month]);
        } else if (mediaType === 'dm') {
          this.dmAdvertisingFee[0][month] = this.numberWithCommas(this.dmAdvertisingFee[0][month]);
        } else {
          this.allAdvertisingFee[0][month] = this.numberWithCommas(this.allAdvertisingFee[0][month]);
        }
      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      }
    },
    data() {
      return {
        wcStatus: [],
        wcMedias: [],
        dmStatus: [],
        dmMedias: [],
        wcAdvertisingFee: [],
        dmAdvertisingFee: [],
        allAdvertisingFee: [],
      }
    }
  }

</script>
<style>

</style>
